var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-connect", "hide-footer": true },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-title" }, [_vm._v("Login")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "go-form-connect-login" }, [
        _c("div", { staticClass: "go-form-header" }, [
          _c("div", { staticClass: "go-brand" }, [
            _c("div", { staticClass: "go-brand-symbol" }, [
              _c("img", {
                attrs: { src: _vm.channelImageUri, alt: _vm.channelName },
              }),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.channelName))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-form-body" },
          [
            _vm.state.oath2
              ? [
                  _c("div", { staticClass: "go-btn-block" }, [
                    _vm.state.oath2Provider === "GOOGLE"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithGoogle.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/google.svg",
                                width: "20",
                                height: "20",
                                alt: "google-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " Google"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state.oath2Provider === "MICROSOFT"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithMicrosoft.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/microsoft.svg",
                                width: "20",
                                height: "20",
                                alt: "microsoft-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " Microsoft"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state.oath2Provider === "DROP_BOX"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithDropbox.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/dropbox.svg",
                                width: "20",
                                height: "20",
                                alt: "dropbox-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " Dropbox"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state.oath2Provider === "FACEBOOK"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithFacebook.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/facebook.svg",
                                width: "20",
                                height: "20",
                                alt: "dropbox-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " Facebook"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state.oath2Provider === "X_TWITTER"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithXTwitter.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/x-twitter.svg",
                                width: "20",
                                height: "20",
                                alt: "dropbox-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " X(Twitter)"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.state.oath2Provider === "WORDPRESS"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login go-btn-login-oath2",
                            attrs: { type: "submit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ssoWithWordpress.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "content/images/images_v4/common/go-icon-channel/wordpress.svg",
                                width: "20",
                                height: "20",
                                alt: "dropbox-favicon",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) + " Wordpress"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              : [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v("Username"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.state.formData.username,
                            expression: "state.formData.username",
                          },
                        ],
                        staticClass: "go-form-control",
                        attrs: { type: "text", placeholder: "Input username" },
                        domProps: { value: _vm.state.formData.username },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.state.formData,
                              "username",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v("Password"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-input-group" }, [
                      (_vm.state.showPassword ? "text" : "password") ===
                      "checkbox"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.state.formData.password,
                                expression: "state.formData.password",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              placeholder: "Input password",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.state.formData.password
                              )
                                ? _vm._i(_vm.state.formData.password, null) > -1
                                : _vm.state.formData.password,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.state.formData.password,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.state.formData,
                                        "password",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.state.formData,
                                        "password",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.state.formData, "password", $$c)
                                }
                              },
                            },
                          })
                        : (_vm.state.showPassword ? "text" : "password") ===
                          "radio"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.state.formData.password,
                                expression: "state.formData.password",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              placeholder: "Input password",
                              type: "radio",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.state.formData.password,
                                null
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.state.formData,
                                  "password",
                                  null
                                )
                              },
                            },
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.state.formData.password,
                                expression: "state.formData.password",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              placeholder: "Input password",
                              type: _vm.state.showPassword
                                ? "text"
                                : "password",
                            },
                            domProps: { value: _vm.state.formData.password },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.state.formData,
                                  "password",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "toggle-password",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.state.showPassword = !_vm.state.showPassword
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "go-icon-16",
                            class: _vm.state.showPassword
                              ? "go-icon-hidden"
                              : "go-icon-view",
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-btn-block" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-login",
                        attrs: { type: "submit" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleLoginByUsernameAndPassword.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("Login")]
                    ),
                  ]),
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }